import React from "react";
import { SelectBox } from "devextreme-react/select-box";
import { CheckBox} from "devextreme-react/check-box";
import {SelectOption} from "../../common/webapicall";
import {toJS} from "mobx";
import {NativeEventInfo} from "devextreme/events";
import dxSelectBox from "devextreme/ui/select_box";

interface Props {
	taxonomies: SelectOption[];
	selectedTaxonomy: string;
	onTaxonomyFilterChanged: (e: NativeEventInfo<dxSelectBox>) => void;

	mediaTypes: SelectOption[];
	selectedMediaType: string;
	onMediaTypeFilterChanged: (e: NativeEventInfo<dxSelectBox>) => void;

	showAllValue: boolean;
	onClickShowAll: () => void;
}

const TrainingContentFilters: React.FC<Props> = ({taxonomies, selectedTaxonomy, onTaxonomyFilterChanged, mediaTypes, selectedMediaType, onMediaTypeFilterChanged, showAllValue, onClickShowAll}) => {
	if (!taxonomies && !mediaTypes) {
		return null;
	}

	return (
		<>
			<div className="cih-learning-filter">
			<div className="cih-select-group">
				<SelectBox
					className="cih-dx-select"
					dataSource={toJS(taxonomies)}					
					value={selectedTaxonomy}
					displayExpr="name"
					valueExpr="value"
					stylingMode="outlined"
					placeholder="Professional characteristics"
					showClearButton
					onValueChanged={(selectedItem) => {
						onTaxonomyFilterChanged(selectedItem.value);
					}}
					
				/>
				<SelectBox
					className="cih-dx-select"
					dataSource={toJS(mediaTypes)}
					value={selectedMediaType}
					displayExpr="name"
					valueExpr="value"
					stylingMode="outlined"
					placeholder="All media"
					showClearButton
					onValueChanged={(selectedItem) => {
						onMediaTypeFilterChanged(selectedItem.value);
					}}
				/>
			</div>
			<div className="cih-chk-wrap">
				<CheckBox width={160} defaultValue={false} value={showAllValue} text="Show all content" onValueChanged={onClickShowAll} />
				</div>
			</div>
		</>
	);
};

export default TrainingContentFilters;
